import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { preprocessResponse } from "../../Report/citationGridUtils";

const ANSWER_MARKDOWN_COMPONENTS = {
	a: ({ href, children }) => (
		<a href={href} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	),
	strong: ({ children }) => <strong>{children}</strong>,
	em: ({ children }) => <em>{children}</em>,
	ul: ({ children }) => <ul>{children}</ul>,
	ol: ({ children }) => <ol>{children}</ol>,
	li: ({ children }) => <li>{children}</li>,
	code: ({ children }) => <code>{children}</code>,
	blockquote: ({ children }) => <blockquote>{children}</blockquote>,
	p: ({ children }) => <p>{children}</p>,
	h1: ({ children }) => <h4>{children}</h4>,
	h2: ({ children }) => <h4>{children}</h4>,
	h3: ({ children }) => <h4>{children}</h4>,
	table: ({ children }) => (
		<div className="monitoring__answer-table-wrap">
			<table>{children}</table>
		</div>
	),
	thead: ({ children }) => <thead>{children}</thead>,
	tbody: ({ children }) => <tbody>{children}</tbody>,
	tr: ({ children }) => <tr>{children}</tr>,
	th: ({ children }) => <th>{children}</th>,
	td: ({ children }) => <td>{children}</td>,
};

function stripTrailingSourcesBlock(text) {
	const raw = String(text || "").replace(/\r\n/g, "\n");
	if (!raw.trim()) return "";

	const headerRe =
		/^[ \t]*(?:\*\*|__|#+\s*)?(?:SOURCES?|Citations?)(?:\*\*|__)?\s*:?[ \t]*$/gim;
	let lastHeader = null;
	let match;
	while ((match = headerRe.exec(raw)) !== null) {
		lastHeader = match;
	}
	if (!lastHeader) return raw.trim();

	const footer = raw.slice(lastHeader.index + lastHeader[0].length);
	const footerLines = footer
		.split("\n")
		.map((line) => line.trim())
		.filter(Boolean);
	const looksLikeSourcesFooter = footerLines.some(
		(line) =>
			/https?:\/\//i.test(line) || /\[Grounded:\s*[^\]]+\]/i.test(line)
	);
	if (!looksLikeSourcesFooter) return raw.trim();

	return raw.slice(0, lastHeader.index).trimEnd();
}

export default function FanoutAnswerPanel({ analysis }) {
	const answerText = stripTrailingSourcesBlock(analysis?.answer_text);

	return (
		<div className="monitoring__analysis-panel monitoring__analysis-panel--answer">
			<h4 className="monitoring__analysis-panel-title">Final answer</h4>
			{analysis?.error ? (
				<p className="small text-danger mb-0">{analysis.error}</p>
			) : answerText ? (
				<div className="monitoring__analysis-answer-body monitoring__answer-body">
					<ReactMarkdown
						remarkPlugins={[remarkGfm]}
						components={ANSWER_MARKDOWN_COMPONENTS}
					>
						{preprocessResponse(answerText)}
					</ReactMarkdown>
				</div>
			) : (
				<p className="text-muted small mb-0">No answer text captured.</p>
			)}
		</div>
	);
}
